import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { AdditionalServicesActionCreator, AppointmentActionCreator, WebOpsActionCreator } from 'src/store/states';
import AdditionalServicePanel from 'src/components/AdditionalServices/AdditionalService/AdditionalServicePanel/AdditionalServicePanel';

const mapStateToProps = (state: IStoreState) => ({
    weOwes: state.AdditionalServices.allServices.weOwes,
    recom: state.AdditionalServices.allServices.recom,
    recalls: state.AdditionalServices.recallData.recalls,
    checkedWeOwes: state.AdditionalServices.checkedWeOwes,
    checkedRecalls: state.AdditionalServices.checkedRecalls,
    checkedRecoms: state.AdditionalServices.checkedRecoms,
    doneElsewhere: state.AdditionalServices.doneElsewhere,
    specData: state.Specs.specs,
    apptOps: state.Appointment.ApptOps,
    appointment: state.Appointment.Appointment,
    apptVeh: state.Appointment.ApptVeh,
    specDefaultDept: state.Specs.specs !== undefined ? state.Specs.specs.departmentFlag : '',
    items: state.WebOps.WebOps,
    sessionId: state.Framework.sessionId,
    lexusMCLaunched: state.Framework.lexusMCLaunched,
    toyotaMCLaunched: state.Framework.toyotaMCLaunched,
    lexusTDMCLaunched: state.Framework.lexusTDMCLaunched,
    toyotaTDMCLaunched: state.Framework.toyotaTDMCLaunched,
    toyotaSSC2Launched: state.Framework.toyotaSSC2Launched,
    lexusSSC2Launched: state.Framework.lexusSSC2Launched,
});

const mapDispatchToProps = {
    toggleWeOwe: AdditionalServicesActionCreator.ToggleWeOwe,
    toggleRecommended: AdditionalServicesActionCreator.ToggleRecommended,
    toggleRecall: AdditionalServicesActionCreator.ToggleRecall,
    toggleDoneElsewhere: AdditionalServicesActionCreator.ToggleDoneElsewhere,
    UpdateApptOps: AppointmentActionCreator.UpdateApptOps,
    determineDept: AppointmentActionCreator.DetermineDept,
    toggleItem: WebOpsActionCreator.ToggleItems,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AdditionalServicePanel);